import { Button } from "primereact/button";
import { useMutation } from "react-relay";
import { toast } from "react-toastify";
import { useTranslation } from "@i18n/hooks";
import { createLimitedCartDiscountButton_CreateLimitedCartDiscountMutation } from "@relay/createLimitedCartDiscountButton_CreateLimitedCartDiscountMutation.graphql";
import { CREATE_LIMITED_CART_DISCOUNT_MUTATION } from "./create-limited-cart-discount-button.graphql";
import { CreateLimitedCartDiscountButtonProps } from "./create-limited-cart-discount-button.interface";

export const CreateLimitedCartDiscountButton = ({
	connectionId,
}: CreateLimitedCartDiscountButtonProps) => {
	const { t } = useTranslation("common");
	const [createLimitedCartDiscount, isCreatingLimitedCartDiscount] =
		useMutation<createLimitedCartDiscountButton_CreateLimitedCartDiscountMutation>(
			CREATE_LIMITED_CART_DISCOUNT_MUTATION,
		);

	const handleOnClick = () => {
		createLimitedCartDiscount({
			variables: {
				connections: [connectionId],
				input: {},
			},
			onCompleted: () => {
				toast.success(t("messages.cartDiscountCreated"));
			},
		});
	};

	return (
		<Button
			label={t("actions.new")}
			onClick={handleOnClick}
			className="ml-auto"
			disabled={isCreatingLimitedCartDiscount}
		/>
	);
};
